import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function HelpCenterFooter() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="text-center mb-6">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Need More Help?</h3>
          <p className="text-gray-600">
            Can't find what you're looking for? Our support team is here to help.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 p-6 border border-gray-200 rounded-lg bg-gray-50">
          <EnvelopeIcon className="h-12 w-12 text-blue-600 flex-shrink-0" />
          <div className="text-center sm:text-left">
            <h4 className="font-semibold text-gray-900 text-lg mb-1">Email Support</h4>
            <p className="text-sm text-gray-600 mb-2">Get help via email within 24 hours</p>
            <a
              href="mailto:support@usegreet.com"
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              support@usegreet.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

